import widgetRoutes from 'enums/routes'
import enthusiastHasRequiredMembership from 'helpers/enthusiastHasRequiredMembership'
import { SchedulablePresenter } from 'shared/presenters'
import { Dispatch, SetStateAction } from 'react'
import { useRouter } from 'next/router'
import { MODAL_IDS } from 'library/molecules/ModalsSchedulableDetails/ModalsSchedulableDetails'
import { useEnthusiast } from 'shared/state/useAuth'
import { MODAL_IDS_AUTH } from 'library/molecules/ModalsAuth'
import useBasketUpdate from './useBasketUpdate/useBasketUpdate'

type ActiveModalId = string | null

export type UseBookOnClickProps = {
  schedulable: SchedulablePresenter
  shoppingBasketDisabled: boolean
  openMembershipModal: boolean
  goToConfig: () => void
  setActiveModalId: Dispatch<SetStateAction<ActiveModalId>>
}

const useBookOnClick = ({
  schedulable,
  shoppingBasketDisabled,
  openMembershipModal,
  goToConfig,
  setActiveModalId
}: UseBookOnClickProps) => {
  const { push, query } = useRouter()
  const widgetSlug = query.widgetSlug as string
  const { enthusiast } = useEnthusiast()

  useBasketUpdate({
    shoppingBasketDisabled
  })

  const bookSchedulableOnClick = () => {
    const userRequiredMembership = enthusiastHasRequiredMembership({
      enthusiast,
      schedulableId: schedulable.id
    })

    if (openMembershipModal && !shoppingBasketDisabled) {
      setActiveModalId(MODAL_IDS.removeMembership)
    } else if (!enthusiast && schedulable.members_only) {
      setActiveModalId(MODAL_IDS_AUTH.signIn)
    } else if (
      (schedulable.members_only && userRequiredMembership) ||
      !schedulable.members_only
    ) {
      goToConfig()
    } else if (
      enthusiast &&
      schedulable.members_only &&
      !userRequiredMembership
    ) {
      push(widgetRoutes.MEMBERSHIPS.url({ widgetSlug }))
    }
  }
  return bookSchedulableOnClick
}

export default useBookOnClick
